<template>
  <w-dialog :show="show"
            show-close
            :wallStyle="{zIndex: 1009}"
            box-style="width: 550px;"
            footer-style="padding-bottom: 24px;border-top: 0;"
            title="移动到"
            @close="cancelHandle">
    <w-row>
      <w-col span="12">
        <w-select size="small" class="w-220" v-model="majorFirst" @change="change()">
          <w-option v-for="(item, idx) in list" :label="item.description" :value="item.catalogIdGuid" :key="'major_' + idx"></w-option>
        </w-select>
      </w-col>
      <w-col span="12">
        <w-select size="small" v-model="majorSecond" :disabled="subList.length < 1" :class="[subList.length < 1 ? 'forbidden' : '']">
          <w-option v-for="(item, idx) in subList" :label="item.description" :value="item.catalogIdGuid" :key="'major_sub_' + idx"></w-option>
        </w-select>
      </w-col>
    </w-row>
    <!--<table class="form-table" width="100%" cellspacing="0" cellpadding="0">-->
      <!--<tbody>-->
      <!--<tr>-->
        <!--<td>-->
          <!--<select size="small" class="w-220" v-model="majorFirst" @change="change()">-->
            <!--<option v-for="(item, idx) in list" :value="item.catalogIdGuid" :key="'major_' + idx">-->
              <!--{{item.description}}-->
            <!--</option>-->
          <!--</select>-->
        <!--</td>-->
        <!--<td>-->
          <!--<select size="small" v-model="majorSecond" :disabled="subList.length < 1" :class="[subList.length < 1 ? 'forbidden' : '']">-->
            <!--<option v-for="(item, idx) in subList" :value="item.catalogIdGuid" :key="'major_sub_' + idx">-->
              <!--{{item.description}}-->
            <!--</option>-->
          <!--</select>-->
        <!--</td>-->
      <!--</tr>-->
      <!--</tbody>-->
    <!--</table>-->
    <template slot="footer">
      <w-button type="primary" @click="submitHandle">确认</w-button>
      <w-button type="minor" @click="cancelHandle">取消</w-button>
    </template>
  </w-dialog>
</template>
<script>
import {capitalize} from '@/assets/utils'
import {mapState} from 'vuex'
export default {
  name: 'DialogMoveTo',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      subList: [],
      majorFirst: '', // professionSelect
      majorSecond: '' // chapterSelect
    }
  },
  computed: {
    ...mapState({
      majorListInventory: state => state.database.majorList.inventory,
      majorListCombination: state => state.database.majorList.combination,
      majorListQuota: state => state.database.majorList.quota,
      majorListMaterial: state => state.database.majorList.material
    }),
    page () {
      const path = this.$route.path
      let page = ''
      let reg = /^\/space\/database\/((inventory)|(combination)|(quota)|(material))\/?/
      if (/^\/database/.test(path)) {
        reg = /^\/database\/basis\/((inventory)|(combination)|(quota)|(material))\/?/
      }
      const matchArr = reg.exec(path)
      if (matchArr && matchArr.length > 1) {
        page = capitalize(matchArr[1])
      }
      return page
    },
    list () {
      let arr = []
      if (this.page) {
        arr = this['majorList' + this.page]
      }
      return arr
    }
  },
  mounted () {
    this.initInput()
  },
  methods: {
    initInput () {
      this.$nextTick(() => {
        if ('professionSelect' in this.editData && this.editData.professionSelect !== '') {
          this.majorFirst = this.editData.professionSelect
          this.change(true)
        } else {
          this.list.length && (this.majorFirst = this.list[0].catalogIdGuid)
          this.change(true)
        }
      })
    },
    change (init) {
      this.majorSecond = ''
      let subList = []
      this.list.forEach((item) => {
        if (this.majorFirst === item.catalogIdGuid) {
          subList = item.children || []
        }
      })
      this.subList = subList
      if (subList.length) {
        if (init && 'chapterSelect' in this.editData && this.editData.chapterSelect !== '') {
          this.majorSecond = this.editData.chapterSelect
        } else {
          this.majorSecond = subList[0].catalogIdGuid
        }
      }
    },
    // 确定
    submitHandle () {
      this.$emit('submit', Object.assign(this.editData, {professionSelect: this.majorFirst, chapterSelect: this.majorSecond}))
    },
    // 取消
    cancelHandle () {
      this.$emit('cancel')
    }
  },
  watch: {
    'show': function () {
      console.log('09090909')
      this.initInput()
    }
  }
}
</script>
<style lang="less" type="text/less">
  select {
    &.w-220{
      width: 220px;
      height: 25px;
    }
  }
</style>
